<template>
    <div v-if="show">
        <div class="d-md-flex align-items-center afiltered pb-2 pb-md-0">
            <div class="m-2 m-md-0 mr-md-1 afiltered-title">Filtros:</div>
            <div class="d-flex flex-wrap mb-2 mb-md-0">
                <div class="d-flex flex-wrap filtered-option m-1" v-for="filter in filtered_categories" :key="filter.id">
                    <a href="#" @click.prevent="remove_category(filter.code)" class="d-flex align-items-center py-1 px-2">
                        <div v-html="filter.name" class="text-center"></div>
                        <div class="ml-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#999999" width="10" height="10" viewBox="0 0 24 24">
                                <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/>
                            </svg>
                        </div>
                    </a>
                </div>
                <div class="d-flex flex-wrap filtered-option m-1" v-for="filter in filtered_brands" :key="filter.id">
                    <a href="#" @click.prevent="remove_brand(filter.id)" class="d-flex align-items-center py-1 px-2">
                        <div v-html="filter.name" class="text-center"></div>
                        <div class="ml-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#999999" width="10" height="10" viewBox="0 0 24 24">
                                <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/>
                            </svg>
                        </div>
                    </a>
                </div>
                <div class="d-flex flex-wrap filtered-option m-1" v-for="filter in filtered_variations" :key="filter.id">
                    <a href="#" @click.prevent="remove_variation(filter.id)" class="d-flex align-items-center py-1 px-2">
                        <div v-html="filter.name" class="text-center"></div>
                        <div class="ml-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#999999" width="10" height="10" viewBox="0 0 24 24">
                                <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/>
                            </svg>
                        </div>
                    </a>
                </div>
            </div>
            <a href="#" @click.prevent="clear_filters" class="filtered-option clear-all-filters px-2">Limpar filtros</a>
        </div>
        <hr class="d-none d-md-block">
    </div>
</template>

<script>
    import utils from "~/mixins/utils";
    import ecommerce_products_filters from "~/mixins/ecommerce_products_filters";

    export default {
        props: {
            brands: {
                type: Array,
                default: () => []
            },
            categories: {
                type: Array,
                default: () => []
            },
            variations: {
                type: Array,
                default: () => []
            }
        },
        mixins: [
            utils,
            ecommerce_products_filters
        ],
        computed: {
            show() {
                try {
                    return typeof this.filter_brands === 'object' && this.filter_brands.length || typeof this.filtered_categories === 'object' && this.filtered_categories.length || typeof this.filtered_variations === 'object' && this.filtered_variations.length
                } catch (e) {
                    console.error(e)
                }
                return false
            },
            filtered_variations() {
                let items = [];
                try {
                    this.variations.forEach(variation => {
                        variation.options.forEach(el => {
                            this.filter_variations.find((filter) => {
                                if (variation.id + '_' + el.id === filter) {
                                    items.push(el)
                                }
                            })
                        })
                    })
                } catch (e) {
                    console.error(e)
                }
                return items
            },
            filtered_brands() {
                try {
                    return this.brands.filter(el => {
                        return this.filter_brands.find((filter) => {
                            return parseInt(el.id) === parseInt(filter)
                        })
                    })
                } catch (e) {
                    console.error(e)
                }
                return []
            },
            filtered_categories() {
                try {
                    return this.categories.filter(el => {
                        return this.filter_categories.find((filter) => {
                            return parseInt(el.code) === parseInt(filter)
                        })
                    })
                } catch (e) {
                    console.error(e)
                }
                return []
            }
        }
    }
</script>
